import React from "react";
import { LanguageLocaleEnum, TranslationBase } from "../../../client/api";
import { showTranslated } from "../../../config/translator";
import EmblemImage from "../EmblemImage";
import PlayerImage from "../PlayerImage";
import ScaleFade from "../Animated/ScaleFade";
import type { Image } from "../../../client/api";

export interface ListItemProps {
  image?: Image | null;
  imageUrl?: string | null;
  playerPhoto?: Image | null;
  title: string | TranslationBase;
  subtitle?: string | TranslationBase | null;
  onClick?: () => void;
  l: LanguageLocaleEnum;
  imageWidth?: number;
  rightElement?: React.ReactNode;
  badgeElement?: React.ReactNode;
}

const ListItem: React.FC<ListItemProps> = ({
  image,
  imageUrl,
  playerPhoto,
  title,
  subtitle,
  onClick,
  l,
  imageWidth = 40,
  rightElement,
  badgeElement
}) => {
  const content = (
    <div className="w-full py-2 flex items-center gap-3 rounded-lg text-left">
      <div className="relative flex-none" style={{ width: imageWidth, height: imageWidth }}>
        {playerPhoto ? (
          <ScaleFade isOpen hoverOnContainer className="w-full h-full">
            <PlayerImage image={playerPhoto} width={imageWidth} round />
          </ScaleFade>
        ) : (
          <ScaleFade isOpen hoverOnContainer className="w-full h-full">
            <EmblemImage image={image} imageUrl={imageUrl} width={imageWidth} />
          </ScaleFade>
        )}
        {badgeElement && (
          <div className="absolute -bottom-2 -right-2 z-10">
            {badgeElement}
          </div>
        )}
      </div>
      <div className="flex flex-col min-w-0 flex-1">
        <span className="text-sm text-font dark:text-font-dark truncate">
          {typeof title === "string" ? title : showTranslated(title, l)}
        </span>
        {subtitle && (
          <span className="text-xs text-font-600 dark:text-font-600-dark truncate">
            {typeof subtitle === "string" ? subtitle : showTranslated(subtitle, l)}
          </span>
        )}
      </div>
      {rightElement && (
        <div className="flex-shrink-0">
          {rightElement}
        </div>
      )}
    </div>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className="w-full">
        {content}
      </button>
    );
  }

  return content;
};

export default ListItem;

